import React, { useState, useEffect, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AuthModal from "../../components/layout/AuthModal";

export default function WebLayout() {
  const { pathname } = useLocation();
  const [authModal, setAuthModal] = useState({ isOpen: false, mode: "login" });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const supportsIntersectionObserver = typeof window !== "undefined" && "IntersectionObserver" in window;

    if (!supportsIntersectionObserver) {
      document.querySelectorAll(".reveal").forEach((el) => el.classList.add("visible"));
      return undefined;
    }

    const timer = setTimeout(() => {
      const els = document.querySelectorAll(".reveal");
      const obs = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            obs.unobserve(entry.target);
          }
        }),
        { threshold: 0.08 }
      );
      els.forEach((el) => obs.observe(el));
    }, 100);

    return () => clearTimeout(timer);
  }, [pathname]);

  const authActions = useMemo(() => ({
    openLogin: () => setAuthModal({ isOpen: true, mode: "login" }),
    openSignup: () => setAuthModal({ isOpen: true, mode: "signup" }),
  }), []);

  return (
    <div className="website-shell min-h-dvh flex flex-col bg-teal-50" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <Navbar
        onLoginClick={authActions.openLogin}
        onSignupClick={authActions.openSignup}
      />
      <main className="flex-1 pt-[calc(100px+env(safe-area-inset-top))] sm:pt-[calc(110px+env(safe-area-inset-top))]">
        <div key={pathname} className="page-enter">
          <Outlet context={authActions} />
        </div>
      </main>
      <Footer onLoginClick={authActions.openLogin} onSignupClick={authActions.openSignup} />
      <AuthModal 
        isOpen={authModal.isOpen} 
        onClose={() => setAuthModal({ isOpen: false, mode: "login" })} 
        initialMode={authModal.mode}
      />
    </div>
  );
}
